'use client';

import { PyBasicAppLoader } from '@repo-ui/code-project/py-basic-app';
import Script from 'next/script';

export default function Page() {
  return (
    <>
      <Script src="/coi-serviceworker.js" defer />
      <PyBasicAppLoader />
    </>
  );
}
